module.exports = "pegasus/assets/theme4/facebook.png";